import * as React from 'react';
import { SelectTrigger } from '@/components/ui/select';
import { cn } from '@/lib/utils';

// Use React.ComponentPropsWithoutRef to get the props type
type StyledSelectTriggerProps = React.ComponentPropsWithoutRef<typeof SelectTrigger>;

/**
 * A styled wrapper around SelectTrigger for the condition builder pills.
 * Applies consistent background, text color, padding, height, and hover states.
 */
const StyledSelectTrigger = React.forwardRef<
  React.ComponentRef<typeof SelectTrigger>,
  StyledSelectTriggerProps
>(({ className, children, ...props }, ref) => (
  <SelectTrigger
    ref={ref}
    className={cn(
      'w-auto flex items-center justify-center h-7 text-sm px-2 border-0 rounded-md',
      'bg-tertiary-sky text-tertiary-sky-foreground hover:bg-tertiary-sky/80',
      'focus:ring-1 focus:ring-ring focus:ring-offset-0', // Add focus ring for accessibility
      className
    )}
    {...props}
  >
    {children}
  </SelectTrigger>
));
StyledSelectTrigger.displayName = 'StyledSelectTrigger';

export { StyledSelectTrigger };
